import { render, staticRenderFns } from "./queueReserve.vue?vue&type=template&id=33536099&scoped=true"
import script from "./queueReserve.vue?vue&type=script&lang=js"
export * from "./queueReserve.vue?vue&type=script&lang=js"
import style0 from "./queueReserve.vue?vue&type=style&index=0&id=33536099&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33536099",
  null
  
)

export default component.exports